import { inject, Injectable } from '@angular/core';
import { BaseHttpService } from '@services/http-base.service';
import { Observable } from 'rxjs';

@Injectable()
export class CatalogsService {
    private readonly http = inject(BaseHttpService);

    /**
     * URL страницы
     */
    url: string = '/rubricator/front_rubricator';

    /**
     * Получение записи
     * @param data данные
     */
    public getItem(data: any): Observable<any> {
        return this.http.client.post<any>(this.http.url + this.url + '/get_item', data, this.http.options);
    }

    /**
     * Сохранение целой записи
     * @param data данные
     */
    public save(data: any): Observable<any> {
        return this.http.client.post<any>(this.http.url + this.url + '/save', data, this.http.options);
    }
}
